import { defaultDataIdFromObject } from 'apollo-cache-inmemory';

const OPERATIONS_TO_INTERCEPT = ['ContentUnifiedQuery'];

export const dataIdFromObject = (object: any) => {
	const operationName = object.__apolloOperationName;

	if (OPERATIONS_TO_INTERCEPT.includes(operationName)) {
		// don't return ids for specific intercepted operations
		// TODO implement logic to check for field structure to prevent writing to cache for specific scenarios
		// eg ContentUnifiedQuery
	}

	if (object.__typename === 'WebItem') {
		return `${object.completeKey || object.id}; ${object.url}`;
	} else if (object.__typename === 'OnboardingState') {
		return object.key;
	} else if (object.__typename === 'WebSection') {
		return object.cacheKey || object.id;
	} else if (object.__typename === 'DetailsSummaryLines') {
		return `${object.macroId}_${object.currentPage}`;
	} else if (object.__typename === 'DetailLine') {
		return `${object.id}_${object.rowId}_${object.macroId}`;
	} else if (object.__typename === 'ConfluenceSystemTemplate') {
		return object.moduleCompleteKey;
	} else if (object.id === null) {
		return;
	}

	return defaultDataIdFromObject(object);
};
